export default {
  TIMEOUT_REFRESH_SAS_TOKEN_IN_MS:
    Number(window._env_?.REACT_APP_TIMEOUT_REFRESH_SAS_TOKEN ?? 0) * 1000,
};
